import React from 'react';
import PropTypes from 'prop-types';
import './CoverflowBase.css'

import TitleAction from './TitleAction';
import ShuffleButton from './ShuffleButton';
import MuteButton from './MuteButton';
import BackButton from './BackButton';
import NextButton from './NextButton';

import PlayButtonV2 from './PlayButtonV2';
import AddPlaylistButton from './AddPlaylistButton';
import AddCartButton from './AddCartButton';
import ContainerBPM from './ContainerBPM';

function ContainerBottomActions({
  title, currentID = null, to = null, bpmAutomix, autoBpmAutomix, isRandom,
  autoBPM, setBPM, callPlay, callPause, prepareNext, preparePrevious, toggleRandom, 
  isLast
}) {
  return (
    <div className={`flexRow align space-between cf-bar-actions`} >
      <TitleAction title={title} id={currentID} to={to} />
      <div className={`flexRow cf-commands space-between align`}>
        <MuteButton />
        <ShuffleButton active={isRandom} onClick={toggleRandom} />
        <BackButton onClick={preparePrevious} />
        <PlayButtonV2 onPlay={callPlay} onPause={callPause} />
        <NextButton onClick={prepareNext} disable={isLast} />
        <AddCartButton />
        <AddPlaylistButton />
      </div>
      <ContainerBPM bpmAutomix={bpmAutomix} autoBpmAutomix={autoBpmAutomix} setBPM={setBPM} autoBPM={autoBPM} />
    </div>
  )
}

ContainerBottomActions.propTypes = {
  currentID: PropTypes.number,
  title: PropTypes.string.isRequired,
  to: PropTypes.string,
  isLast: PropTypes.bool
}

export default ContainerBottomActions;
